export class Controller {

    $onChanges() {
        this.tooltipKey = ({
            HARD_TOKEN_USER: 'sp-user-type.hard-token-user',
            REGULAR_USER: 'sp-user-type.regular-user',
            SMS_USER: 'sp-user-type.sms-user',
        })[this.userType];

        this.iconClass = ({
            HARD_TOKEN_USER: 'text-primary fas fa-lg fa-calculator',
            REGULAR_USER: 'text-primary fa fa-lg fa-mobile-alt',
            SMS_USER: 'text-primary fa fa-lg fa-comment',
        })[this.userType];
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-user-type/sp-user-type.controller.js